import React from "react";
import "../../styles/espCardView.scss";
import ReactDatePicker from "react-datepicker";
import { Button } from "../../common/Button/Button";
import { useEffect } from "react";
import { useState } from "react";
import Spinner from "../../common/Spinner/Spinner";
import api from "../../utils/api";
import Chart from "react-google-charts";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
//import ESPDashboardGrid from "../../components/EServicePartnerServiceRequests/ESPDashboardGrid";
import EngagedDashboardGrid from "../../components/EServicePartnerServiceRequests/EngagedDashboardGrid";
import { SELECTED_SIDE_BAR_ITEM_KEY } from "../../common/SidebarContent/SidebarContent";
import { toast } from "react-toastify";
import { getESPUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import ic_filter from "./../../assets/ic_filter.svg";
import SPLedDashboardFilterModal from "../../components/EServicePartnerServiceRequests/SPLedDashboardFilterModal";
import moment from "moment";

//for admin 
import { getUser } from "../../utils/localStorage";

export default function EngagedUsersReportDashboard(props)
{
    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/dashboard");
    const history = useHistory();
    var PastDate = new Date();
    PastDate.setMonth(PastDate.getMonth() - 1);
    const strData2={
        "ServiceRequests": 200,
        "Open": 20,
        "Delivered": 10,
        "Cancelled": 10,
        "TableData":[
        {
            "ServiceName":"Go Online",
            "Requested": 10,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":10,
            "Full_Payment_Received":10,
            "Delivered":10,
            "Cancelled":10,
        },
       {
            "ServiceName":"GST Registration",
            "Requested": 10,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":10,
            "Full_Payment_Received":10,
            "Delivered":10,
            "Cancelled":10,
        },
        {
            "ServiceName":"Shop Act Intimation",
            "Requested": 10,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":10,
            "Full_Payment_Received":10,
            "Delivered":10,
            "Cancelled":10,
        },
        {
            "ServiceName":"Business Planning",
            "Requested": 10,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":10,
            "Full_Payment_Received":10,
            "Delivered":10,
            "Cancelled":10,
        },
        {
            "ServiceName":"Funding proposal creation",
            "Requested": 10,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":10,
            "Full_Payment_Received":10,
            "Delivered":10,
            "Cancelled":10,
        },
        {
            "ServiceName":"Social Media Management",
            "Requested": 10,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":10,
            "Full_Payment_Received":10,
            "Delivered":10,
            "Cancelled":10,
        },        
    ]};
    const strData={
        "ServiceRequests": 100,
        "Open": 10,
        "Delivered": 25,
        "Cancelled": 5,
        "TableData":[
        {
            "ServiceName":"Go Online",
            "Requested": 10,
            "Eligible": 78,
            "Quotation_Sent":48,
            "Prepared": 53,
            "Partial_Payment_Pending": 66,
            "Payment_Received": 42,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":46,
            "Service_Delivery_Start":42,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":46,
            "Full_Payment_Received":10,
            "Delivered":35,
            "Cancelled":75,
        },
       {
            "ServiceName":"GST Registration",
            "Requested": 65,
            "Eligible": 49,
            "Quotation_Sent":89,
            "Prepared": 36,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 420,
            "Ready_For_Progression":75,
            "Payment_Confirmed_By_Partner":185,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":145,
            "Service_Deliverables_Ready":63,
            "Full_Payment_Requested":25,
            "Full_Payment_Received":10,
            "Delivered":74,
            "Cancelled":10,
        },
        {
            "ServiceName":"Shop Act Intimation",
            "Requested": 75,
            "Eligible": 68,
            "Quotation_Sent":10,
            "Prepared": 65,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 48,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":47,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":63,
            "Service_Deliverables_Ready":52,
            "Full_Payment_Requested":54,
            "Full_Payment_Received":125,
            "Delivered":56,
            "Cancelled":52,
        },
        {
            "ServiceName":"Business Planning",
            "Requested": 58,
            "Eligible": 45,
            "Quotation_Sent":10,
            "Prepared": 10,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":15,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":50,
            "Full_Payment_Received":14,
            "Delivered":30,
            "Cancelled":65,
        },
        {
            "ServiceName":"Funding proposal creation",
            "Requested": 10,
            "Eligible": 12,
            "Quotation_Sent":13,
            "Prepared": 20,
            "Partial_Payment_Pending": 140,
            "Payment_Received": 10,
            "Ready_For_Progression":13,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":40,
            "Service_Deliverables_Ready":45,
            "Full_Payment_Requested":40,
            "Full_Payment_Received":15,
            "Delivered":10,
            "Cancelled":10,
        },
        {
            "ServiceName":"Social Media Management",
            "Requested": 50,
            "Eligible": 10,
            "Quotation_Sent":10,
            "Prepared": 14,
            "Partial_Payment_Pending": 10,
            "Payment_Received": 10,
            "Ready_For_Progression":14,
            "Payment_Confirmed_By_Partner":10,
            "Awaiting_For_Information_Documents":10,
            "Service_Delivery_Start":10,
            "Service_Deliverables_Ready":15,
            "Full_Payment_Requested":55,
            "Full_Payment_Received":15,
            "Delivered":14,
            "Cancelled":10,
        },        
    ]};
    const [isLoading, setIsLoading] = useState(false);
    const [ServiceData,setServiceData] =useState([]);
    const [firstTimeResponseData,setFirstTimeResponseData] =useState(
        {
            services_followed_tat_count:0,
            services_not_followed_tat_count:0,
            avarage_time_response_before_tat:"00 hr 00 mins",
            avarage_time_response_after_tat:"00 hr 00 mins",
            ideal_tat:0
        }
    );

    const [customerSatisfactionScoreData,setSustomerSatisfactionScoreData] =useState(
        {
            positive_response:0,
            negative_response:0,
            average_positive_response:0.0
        }
    );
    const [signedUpServicesCount,setsignedUpServicesCount] =useState(0);
    const [deliveredServicesCount,setDeliveredServicesCount] =useState(0);
    const [TableData,setTableData] =useState([]);
    const [ChartData,setChartData] =useState([]);
    const [fromDate, setfromDate] = useState(PastDate);
    const [toDate, settoDate] = useState(new Date());
    const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
    const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
    const [Signed_up_to_Service_Requested,setSigned_up_to_Service_Requested] =useState("0.00%");
    const [Delivered_to_Signed_Up,setDelivered_to_Signed_Up] =useState("0.00%");
    const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
    const [signedUpTarget,setSignedUpTarget] =useState(100);
    const [deliveredTarget,setDeliveredTarget] =useState(100);

    const [signedUpTargetPer,setSignedUpTargetPer] =useState(0);
    const [deliveredTargetPer,setDeliveredTargetPer] =useState(0);
    const [signedUpActualPer,setSignedUpActualPer] =useState(0);
    const [deliveredActualPer,setDeliveredActualPer] =useState(0);
    const [signedUpToDeliveredPer,setSignedUpToDeliveredPer] =useState("0.00%");
    const [deliveredToSignedUpPer,setDeliveredToSignedUpPer] =useState("0.00%");
    

    //for admin
    const[activePage,setActivePage]=useState("");  
    const [MainExterServicePartnerList, setMainExterServicePartnerList] = useState([]);
    const [MainServiceRequestsNameList, setMainServiceRequestsNameList] = useState([]);
    const [externalServicePartnerList,setExternalServicePartnerList] = useState([]);
    const [selectedExternalServicePartner,setselectedExternalServicePartner] = useState(null);

    const Data = [];
    const arrChartData = [];
    const chartEvents =[
    {
        eventName: "select",
        callback: ({ chartWrapper, google}) =>{
            const selectedId = chartWrapper.getChart().getSelection();
            if (selectedId.length) 
            {
                console.log("Selected Country", ChartData[selectedId[0].row + 1][0]);
                onChartClick(ChartData[selectedId[0].row + 1][0]);
            }
        }
    },];

    const pieEvents =[
    {
        eventName: "select",
        callback: ({ chartWrapper, google}) =>{
            const selectedId = chartWrapper.getChart().getSelection();
            let s=selectedId;
            let responseType='';

            if(selectedId[0].row==1)
            {
                responseType='positive';
            }
            else{
                responseType='negative';
            }

            if(history.location.pathname.includes("/home/engagedusers-report"))
            {
                localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/spled-service-requests");
                history.push({
                    pathname: "/home/spled-service-requests",
                    currentActiveTab:"Customer Feedback",
                    FfromDate:fromDate,
                    FtoDate:toDate,
                    responseType:responseType,
                    selectedExternalServicePartner:selectedExternalServicePartner,
                });
            }
            else
            {
                localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
                history.push({
                    pathname: "/service_partner/service-requests",
                    currentActiveTab:"Customer Feedback",
                    FfromDate:fromDate,
                    FtoDate:toDate,
                    responseType:responseType
                });
            }            
        }
    },];

    const frtEvents =[
        {
            eventName: "select",
            callback: ({ chartWrapper, google}) =>{
                const selectedId = chartWrapper.getChart().getSelection();
                let s=selectedId;
                let requestWithinTAT='';

                if(selectedId[0].column==1)
                {
                    requestWithinTAT='yes';
                }
                else{
                    requestWithinTAT='no';
                }

                if(history.location.pathname.includes("/home/engagedusers-report"))
                {
                    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/spled-service-requests");
                    history.push({
                        pathname: "/home/spled-service-requests",
                        fromDate:fromDate,
                        toDate:toDate,
                        requestWithinTAT:requestWithinTAT,
                        selectedExternalServicePartner:selectedExternalServicePartner,
                    });
                }
                else
                {
                    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
                    history.push({
                        pathname: "/service_partner/service-requests",
                        fromDate:fromDate,
                        toDate:toDate,
                        requestWithinTAT:requestWithinTAT,
                    });
                }
    
                
            }
        },];

    const SignedUpEvents =[
        {
            eventName: "select",
            callback: ({ chartWrapper, google}) =>{
                
                if(history.location.pathname.includes("/home/engagedusers-report"))
                {
                    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/spled-service-requests");
                    history.push({
                        pathname: "/home/spled-service-requests",
                        fromDate:fromDate,
                        toDate:toDate,
                        signedUpRequests:"yes",
                        selectedExternalServicePartner:selectedExternalServicePartner,
                    });
                }
                else
                {
                    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
                    history.push({
                        pathname: "/service_partner/service-requests",
                        fromDate:fromDate,
                        toDate:toDate,
                        signedUpRequests:"yes"
                    });
                }
                
            }
        },];

    const DeliveredEvents =[
        {
            eventName: "select",
            callback: ({ chartWrapper, google}) =>{
                if(history.location.pathname.includes("/home/engagedusers-report"))
                {
                    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/spled-service-requests");
                    history.push({
                        pathname: "/home/spled-service-requests",
                        fromDate:fromDate,
                        toDate:toDate,
                        sStatus:'Delivered',
                        selectedExternalServicePartner:selectedExternalServicePartner,
                    });
                }
                else
                {
                    localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
                    history.push({
                        pathname: "/service_partner/service-requests",
                        fromDate:fromDate,
                        toDate:toDate,
                        sStatus:'Delivered'
                    });
                }
            }
        },];

    /*Filter modal callbacks */
	const [showFilterModal, setShowFilterModal] = useState(false);
	const toggleFilterModal = () => {
		setShowFilterModal(!showFilterModal);
	};
	const handleViewFilterModal = () => {
		toggleFilterModal();
	};
	/*End */

    const onChartClick=(ev)=>{
        var eve=ev;
        if(history.location.pathname.includes("/home/engagedusers-report"))
        {
            localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/spled-service-requests");
            history.push({
                pathname: "/home/spled-service-requests",
                sStatus:ev,
                ServiceNameListForFilter:selectedServiceNameListForFilter,
                fromDate:fromDate,
                toDate:toDate,
                selectedExternalServicePartner:selectedExternalServicePartner,
                PackageNameListForFilter:selectedPackageNameListForFilter,
            });
        }
        else{
            localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/service-requests");
            history.push({
                pathname: "/service_partner/service-requests",
                sStatus:ev,
                ServiceNameListForFilter:selectedServiceNameListForFilter,
                fromDate:fromDate,
                toDate:toDate,
                PackageNameListForFilter:selectedPackageNameListForFilter,
                
            });
        }
        
    } 

    useEffect(() => {

        if(history.location.pathname.includes("/home/engagedusers-report"))
        {
            if (!getUser()) 
            {
                history.push("/login");
            }
            else
            {
                const user = getUser();
                const hasSPReportRole = user.role.includes(9);
                if (hasSPReportRole) 
                {
                    setActivePage("SPLedDashboard");
                    api.getAllExternalServicePartners()
                    .then((d) => 
                    {
                        var exterServicePartners=[];
                        d.data.map((f) => 
                        {
                            if(f.sServicePartnerEmail)
                            {
                                exterServicePartners.push(f);
                            }
                        });
                        setMainExterServicePartnerList(exterServicePartners);
                    });
    
                    /*api.getAllPackageCatalogues().then(({ data }) => 
                    {
                        const packageNamesForFilter =[];
                        Object.keys(data).map((idx) => {
                            if(data[idx].sPackageOfferStatus==='Published')
                            {
                                packageNamesForFilter.push( {
                                    label: data[idx].sPackageOfferTitle,
                                    value: data[idx].id,
                                });
                            }
                        });
                        setPackageNameListForFilter(packageNamesForFilter);
                    });*/
    
                    api.getDisableFalseServiceRequestsNames({bDisableService:false})
                    .then(({ data }) => {
                        setMainServiceRequestsNameList(data);
                    });
                }
                else
                {
                    setActivePage("No_Access");
                } 
            }
        }
        else
        {
            if (!getESPUser()) {
                history.push("/service_partner/login");
            }
            else
            {
                setActivePage("SPLedDashboard");
                var user=getESPUser();
                var ESPServiceCodeList=[];
                if (user&&user.external_partner_details&&user.external_partner_details.sServiceCode_list)
                {
                    ESPServiceCodeList=user.external_partner_details.sServiceCode_list;
                }
    
                api.getAllPackageCatalogues().then(({ data }) => 
                {
                    const packageNamesForFilter =[];
                     Object.keys(data).map((idx) => {
                         if(data[idx].sPackageOfferStatus==='Published')
                         {
                            packageNamesForFilter.push( {
                                label: data[idx].sPackageOfferTitle,
                                value: data[idx].id,
                            });
                         }
                    });
                    setPackageNameListForFilter(packageNamesForFilter);
                });
    
                api.getDisableFalseServiceRequestsNames({bDisableService:false})
                .then(({ data }) => {
                    const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
                        return {
                            label: data[idx].sServiceName,
                            id: data[idx].id,
                            value: data[idx].sServiceCode,
                        };
                    });
        
                    let tempserviceReqNamesForFilter=[];
                    if(ESPServiceCodeList.length>0)
                    {
                        serviceReqNamesForFilter.map((e) => {
                            if(ESPServiceCodeList.includes(e.value))
                            {
                                tempserviceReqNamesForFilter.push(e);
                            }
                        });
                    }
                    else
                    {
                        tempserviceReqNamesForFilter=serviceReqNamesForFilter;
                    }
    
                    setServiceNameListForFilter(tempserviceReqNamesForFilter);
                    getESPServiceData();
                    getFirstResponseTimeData();
                    getCustomerSatisfactionScoreData();
    
                    let temp =[{label: "All", value: "*"}];
                    let tempSR = tempserviceReqNamesForFilter.map((e) => 
                    {
                        if (!temp.includes(e)) 
                        {
                            temp = temp.concat(e);
                        }
                        return e;
                    });
                    setSelectedServiceNameListForFilter(temp);
                    setServiceNameListForFilter(tempSR);                
                });
            }
        }
        
	},[]);

    useEffect(() => {
        if(history.location.pathname.includes("/home/engagedusers-report"))
        {
            let externalServicePartners = MainExterServicePartnerList.map((f) => 
            {
                return {
                    value: f["sServicePartnerEmail"],
                    label: f["sName"]+(f["sServicePartnerOrg"]?("("+f["sServicePartnerOrg"]+")"):""),
                };
            });
            setExternalServicePartnerList(externalServicePartners);
            onExternalServicePartnerChange(externalServicePartners[0]);
        }
        
	},[MainExterServicePartnerList,MainServiceRequestsNameList]);

    useEffect(() => {
        if(selectedExternalServicePartner)
        {
            if(history.location.pathname.includes("/home/engagedusers-report"))
            {
                let filterParameters = {};
                filterParameters.email = selectedExternalServicePartner.value;
                api.getAllPackageCatalogues(filterParameters).then(({ data }) => 
                {
                    const packageNamesForFilter =[];
                    Object.keys(data).map((idx) => {
                        if(data[idx].sPackageOfferStatus==='Published')
                        {
                            packageNamesForFilter.push( {
                                label: data[idx].sPackageOfferTitle,
                                value: data[idx].id,
                            });
                        }
                    });
                    setPackageNameListForFilter(packageNamesForFilter);
                });
                getESPServiceData();
                getFirstResponseTimeData();
                getCustomerSatisfactionScoreData();
                //setShowFilterModal(false);
            }
        }
	},[selectedExternalServicePartner]);

    useEffect(() => {
        setESPServiceTableData();
	},[ServiceData]);

    useEffect(() => {
        setESPServiceChartData();
	},[ServiceData,selectedServiceNameListForFilter]);

    /*useEffect(() => {
        getESPServiceData();
        getFirstResponseTimeData();
        getCustomerSatisfactionScoreData();
	},[selectedPackageNameListForFilter]);*/

    const getFirstResponseTimeData=()=>{

        let filterParameters = {};

        if (history.location.pathname.includes("/home/engagedusers-report")&&selectedExternalServicePartner) 
        {
            filterParameters.EmailAddress = selectedExternalServicePartner.value;
        }

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }

        //setIsLoading(true);	
        const { tempServices } = api.getFirstTimeResponseData(filterParameters).then(({ data }) => {
            //setIsLoading(false);
			if(data)
            {
                setFirstTimeResponseData(data);
            }
            else
            {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
		}).catch((error) =>
        {
            //setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            
        });
    }

    const getCustomerSatisfactionScoreData=()=>{

        let filterParameters = {};

        if (history.location.pathname.includes("/home/engagedusers-report")&&selectedExternalServicePartner) 
        {
            filterParameters.EmailAddress = selectedExternalServicePartner.value;
        }

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }

        //setIsLoading(true);	
        const { tempServices } = api.getCustomerSatisfactionScoreData(filterParameters).then(({ data }) => {
            //setIsLoading(false);
			if(data)
            {
                setSustomerSatisfactionScoreData(data);
            }
            else
            {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
		}).catch((error) =>
        {
            //setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            
        });
    }

    const getESPServiceData=()=>{
        let filterParameters = {};
        let serviceRequestListtemp2 = [];
        selectedServiceNameListForFilter.map((e) => {
            if(e.value!="*")
            {
                serviceRequestListtemp2.push(e.value);
            }
        });

        const serviceRequestList=serviceRequestListtemp2;

        if (serviceRequestList.length) 
        {
            //filterParameters.service_codes = serviceRequestList;
        }

        if (history.location.pathname.includes("/home/engagedusers-report")&&selectedExternalServicePartner) 
        {
            filterParameters.EmailAddress = selectedExternalServicePartner.value;
        }

        if (selectedPackageNameListForFilter) 
        {
            filterParameters.nPackageCatalogueId = selectedPackageNameListForFilter.value;
        }

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }

        let stesc=filterParameters;
        setIsLoading(true);	
        const { tempServices } = api.getExternalPartnerServicesDashboradData(filterParameters).then(({ data }) => {
            setIsLoading(false);
			if(data)
            {
                calculateDaysLeft(fromDate,toDate);
                setServiceData(data);
            }
            else
            {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
		}).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            
        });
    }

    const setESPServiceTableData =()=>{ 
        
        if(ServiceData.TableData)    
        {
            //Clear array
            Data.length=0;
            //arrChartData.length=0;

            let arr_Requested = {Status:"Requested"}; 
            let arr_Eligible = {Status:"Eligible"};
            let arr_Quotation_Sent = {Status:"Quotation Sent"};
            let arr_Prepared = {Status:"Prepared"};
            let arr_Partial_Payment_Pending = {Status:"Partial Payment Pending"};
            let arr_Payment_Received ={Status:"Payment Received"};
            let arr_Ready_For_Progression = {Status:"Ready For Progression"};
            let arr_Payment_Confirmed_By_Partner = {Status:"Payment Confirmed By Partner"};
            let arr_Awaiting_For_Information_Documents = {Status:"Awaiting For Information/Documents"};
            let arr_Service_Delivery_Start = {Status:"Service Delivery Start"};
            let arr_Service_Deliverables_Ready = {Status:"Service Deliverables ready"};
            let arr_Full_Payment_Requested = {Status:"Full Payment Requested"};
            let arr_Full_Payment_Received = {Status:"Full Payment Received"};
            let arr_Delivered = {Status:"Delivered"};
            let arr_Cancelled = {Status:"Cancelled"};
            let arr_Services_Signed_up = {Status:"Services Signed up"};
            let arr_Signed_up_to_service_requested = {Status:"% Signed up to Service Requested"};
            let arr_Delivered_to_Signed_Up = {Status:"% Delivered to Signed Up"};

            /*let count_Requested = 0; 
            let count_Eligible = 0;
            let count_Quotation_Sent = 0;
            let count_Prepared = 0;
            let count_Partial_Payment_Pending = 0;
            let count_Payment_Received =0;
            let count_Ready_For_Progression = 0;
            let count_Payment_Confirmed_By_Partner = 0;
            let count_Awaiting_For_Information_Documents = 0;
            let count_Service_Delivery_Start = 0;
            let count_Service_Deliverables_Ready = 0;
            let count_Full_Payment_Requested = 0;
            let count_Full_Payment_Received = 0;
            let count_Delivered = 0;
            let count_Cancelled = 0;*/

            ServiceData.TableData.map((e) => {
                var sername=e.ServiceName.replace(/ /g, '').replace(/\./g,'');
                arr_Requested={...arr_Requested,[sername]:e["Requested"]};
                arr_Eligible={...arr_Eligible,[sername]:e["Eligible"]};
                arr_Quotation_Sent={...arr_Quotation_Sent,[sername]:e["Quotation Sent"]};
                arr_Prepared={...arr_Prepared,[sername]:e["Prepared"]};
                arr_Partial_Payment_Pending={...arr_Partial_Payment_Pending,[sername]:e["Partial Payment Pending"]};
                arr_Payment_Received={...arr_Payment_Received,[sername]:e["Payment Received"]};
                arr_Ready_For_Progression={...arr_Ready_For_Progression,[sername]:e["Ready For Progression"]};
                arr_Awaiting_For_Information_Documents={...arr_Awaiting_For_Information_Documents,[sername]:e["Awaiting For Information/Documents"]};
                arr_Payment_Confirmed_By_Partner={...arr_Payment_Confirmed_By_Partner,[sername]:e["Payment Confirmed By Partner"]};
                arr_Service_Delivery_Start={...arr_Service_Delivery_Start,[sername]:e["Service Delivery Start"]};
                arr_Service_Deliverables_Ready={...arr_Service_Deliverables_Ready,[sername]:e["Service Deliverables ready"]};
                arr_Full_Payment_Requested={...arr_Full_Payment_Requested,[sername]:e["Full Payment Requested"]};
                arr_Full_Payment_Received={...arr_Full_Payment_Received,[sername]:e["Full Payment Received"]};
                arr_Delivered={...arr_Delivered,[sername]:e["Delivered"]};
                arr_Cancelled={...arr_Cancelled,[sername]:e["Cancelled"]};

                let serviceRequestsCount=(parseInt(e["Requested"])+parseInt(e["Eligible"])+parseInt(e["Quotation Sent"])+parseInt(e["Prepared"])+parseInt(e["Partial Payment Pending"])+parseInt(e["Ready For Progression"])+parseInt(e["Awaiting For Information/Documents"])+parseInt(e["Service Delivery Start"])+parseInt(e["Service Deliverables ready"])+parseInt(e["Full Payment Requested"])+parseInt(e["Full Payment Received"])+parseInt(e["Cancelled"]));
                let Services_Signed_up=(parseInt(e["Payment Received"])+parseInt(e["Payment Confirmed By Partner"])+parseInt(e["Delivered"]));
                let TotalServiceRequests=Services_Signed_up+serviceRequestsCount;
                let TotalDeliveredServices=parseInt(e["Delivered"]);
                let Signed_up_to_service_requested=((Services_Signed_up/TotalServiceRequests)*100).toFixed(2);
                let Delivered_to_Signed_Up=((TotalDeliveredServices/Services_Signed_up)*100).toFixed(2);

                arr_Services_Signed_up={...arr_Services_Signed_up,[sername]:Services_Signed_up}

                if(Signed_up_to_service_requested==="NaN")
                {
                    Signed_up_to_service_requested="0.00";
                }

                if(Delivered_to_Signed_Up==="NaN")
                {
                    Delivered_to_Signed_Up="0.00";
                }

                arr_Signed_up_to_service_requested={...arr_Signed_up_to_service_requested,[sername]:Signed_up_to_service_requested+"%"}
                arr_Delivered_to_Signed_Up={...arr_Delivered_to_Signed_Up,[sername]:Delivered_to_Signed_Up+"%"}

                /*count_Requested=count_Requested+parseInt(e["Requested"]);
                count_Eligible=count_Eligible+parseInt(e["Eligible"]);
                count_Quotation_Sent=count_Quotation_Sent+parseInt(e["Quotation Sent"]);
                count_Prepared=count_Prepared+parseInt(e["Prepared"]);
                count_Partial_Payment_Pending=count_Partial_Payment_Pending+parseInt(e["Partial Payment Pending"]);
                count_Payment_Received=count_Payment_Received+parseInt(e["Payment Received"]);
                count_Ready_For_Progression=count_Ready_For_Progression+parseInt(e["Ready For Progression"]);
                count_Payment_Confirmed_By_Partner=count_Payment_Confirmed_By_Partner+parseInt(e["Payment Confirmed By Partner"]);
                count_Awaiting_For_Information_Documents=count_Awaiting_For_Information_Documents+parseInt(e["Awaiting For Information/Documents"]);
                count_Service_Delivery_Start=count_Service_Delivery_Start+parseInt(e["Service Delivery Start"]);
                count_Service_Deliverables_Ready=count_Service_Deliverables_Ready+parseInt(e["Service Deliverables ready"]);
                count_Full_Payment_Requested=count_Full_Payment_Requested+parseInt(e["Full Payment Requested"]);
                count_Full_Payment_Received=count_Full_Payment_Received+parseInt(e["Full Payment Received"]);
                count_Delivered=count_Delivered+parseInt(e["Delivered"]);
                count_Cancelled=count_Cancelled+parseInt(e["Cancelled"]);*/
            });

            Data.push(arr_Requested);
            Data.push(arr_Eligible);
            Data.push(arr_Quotation_Sent);
            Data.push(arr_Prepared);
            Data.push(arr_Partial_Payment_Pending);
            Data.push(arr_Payment_Received);
            Data.push(arr_Ready_For_Progression);
            Data.push(arr_Awaiting_For_Information_Documents);
            Data.push(arr_Payment_Confirmed_By_Partner);
            Data.push(arr_Service_Delivery_Start);
            Data.push(arr_Service_Deliverables_Ready);
            Data.push(arr_Full_Payment_Requested);
            Data.push(arr_Full_Payment_Received);
            Data.push(arr_Delivered);
            Data.push(arr_Cancelled);
            Data.push(arr_Services_Signed_up);
            Data.push(arr_Signed_up_to_service_requested);
            Data.push(arr_Delivered_to_Signed_Up);
            const finalData=Data
            setTableData(finalData);


            let finaldatanew=ServiceData.TableData.map((e) => {

                let serviceRequestsCount=(parseInt(e["Requested"])+parseInt(e["Eligible"])+parseInt(e["Quotation Sent"])+parseInt(e["Prepared"])+parseInt(e["Partial Payment Pending"])+parseInt(e["Ready For Progression"])+parseInt(e["Awaiting For Information/Documents"])+parseInt(e["Service Delivery Start"])+parseInt(e["Service Deliverables ready"])+parseInt(e["Full Payment Requested"])+parseInt(e["Full Payment Received"])+parseInt(e["Cancelled"]));
                let Services_Signed_up=(parseInt(e["Payment Received"])+parseInt(e["Payment Confirmed By Partner"])+parseInt(e["Delivered"]));
                let TotalServiceRequests=Services_Signed_up+serviceRequestsCount;
                let TotalDeliveredServices=parseInt(e["Delivered"]);
                let Signed_up_to_service_requested=((Services_Signed_up/TotalServiceRequests)*100).toFixed(2);
                let Delivered_to_Signed_Up=((TotalDeliveredServices/Services_Signed_up)*100).toFixed(2);

                if(Signed_up_to_service_requested==="NaN")
                {
                    Signed_up_to_service_requested="0.00";
                }

                if(Delivered_to_Signed_Up==="NaN")
                {
                    Delivered_to_Signed_Up="0.00";
                }

                e.Services_Signed_up=Services_Signed_up;
                e.Signed_up_to_service_requested=Signed_up_to_service_requested+"%";
                e.Delivered_to_Signed_Up=Delivered_to_Signed_Up+"%";
                return e;
            });

            setTableData(finaldatanew);

            /*arrChartData.push(
                ['Services', 'number'],
                ['Requested', count_Requested],
                ['Eligible', count_Eligible],
                ['Quotation Sent', count_Quotation_Sent],
                ['Prepared', count_Prepared],
                ['Partial Payment Pending', count_Partial_Payment_Pending],
                ['Payment Received', count_Payment_Received],
                ['Ready For Progression', count_Ready_For_Progression],
                ['Awaiting For Information/Documents',count_Awaiting_For_Information_Documents],
                ['Payment Confirmed By Partner', count_Payment_Confirmed_By_Partner],
                ['Service Delivery Start', count_Service_Delivery_Start],
                ['Service Deliverables ready', count_Service_Deliverables_Ready],
                ['Full Payment Requested', count_Full_Payment_Requested],
                ['Full Payment Received', count_Full_Payment_Received],
                ['Delivered', count_Delivered],
                ['Cancelled', count_Cancelled],
            );
            setChartData(arrChartData);

            let Services_Signed_upCount=count_Eligible+count_Quotation_Sent+
            count_Prepared+count_Partial_Payment_Pending+count_Payment_Received+count_Ready_For_Progression+
            count_Awaiting_For_Information_Documents+count_Payment_Confirmed_By_Partner+count_Service_Delivery_Start+
            count_Service_Deliverables_Ready+count_Full_Payment_Requested+count_Full_Payment_Received;

            let totalServiceRequets=count_Requested+Services_Signed_upCount+count_Delivered+ count_Cancelled;

            let Total_Services_Signed_up_per=((Services_Signed_upCount/totalServiceRequets)*100).toFixed(2);
            let Total_Delivered_To_SignedUp_per=((count_Delivered/totalServiceRequets)*100).toFixed(2);

            setSigned_up_to_Service_Requested(Total_Services_Signed_up_per+"%");
            setDelivered_to_Signed_Up(Total_Delivered_To_SignedUp_per+"%");*/
        } 
    }

    const setESPServiceChartData =()=>{ 
        
        if(ServiceData.TableData)    
        {
            //Clear array
            arrChartData.length=0;

            let count_Requested = 0; 
            let count_Eligible = 0;
            let count_Quotation_Sent = 0;
            let count_Prepared = 0;
            let count_Partial_Payment_Pending = 0;
            let count_Payment_Received =0;
            let count_Ready_For_Progression = 0;
            let count_Payment_Confirmed_By_Partner = 0;
            let count_Awaiting_For_Information_Documents = 0;
            let count_Service_Delivery_Start = 0;
            let count_Service_Deliverables_Ready = 0;
            let count_Full_Payment_Requested = 0;
            let count_Full_Payment_Received = 0;
            let count_Delivered = 0;
            let count_Cancelled = 0;

            let totalSelectedServiceCount=0;

            let totalSignedUpTargetPercentage=0;
            let totalDeliveredTargetPercentage=0;
            let totalSignedUpActualPercentage=0;
            let totalDeliveredActualPercentage=0;

            selectedServiceNameListForFilter.map((d) => {
                if(d.value!="*")
                {
                    ServiceData.TableData.map((e) => {
                        if(d.label===e.ServiceName)
                        {
                            count_Requested=count_Requested+parseInt(e["Requested"]);
                            count_Eligible=count_Eligible+parseInt(e["Eligible"]);
                            count_Quotation_Sent=count_Quotation_Sent+parseInt(e["Quotation Sent"]);
                            count_Prepared=count_Prepared+parseInt(e["Prepared"]);
                            count_Partial_Payment_Pending=count_Partial_Payment_Pending+parseInt(e["Partial Payment Pending"]);
                            count_Payment_Received=count_Payment_Received+parseInt(e["Payment Received"]);
                            count_Ready_For_Progression=count_Ready_For_Progression+parseInt(e["Ready For Progression"]);
                            count_Payment_Confirmed_By_Partner=count_Payment_Confirmed_By_Partner+parseInt(e["Payment Confirmed By Partner"]);
                            count_Awaiting_For_Information_Documents=count_Awaiting_For_Information_Documents+parseInt(e["Awaiting For Information/Documents"]);
                            count_Service_Delivery_Start=count_Service_Delivery_Start+parseInt(e["Service Delivery Start"]);
                            count_Service_Deliverables_Ready=count_Service_Deliverables_Ready+parseInt(e["Service Deliverables ready"]);
                            count_Full_Payment_Requested=count_Full_Payment_Requested+parseInt(e["Full Payment Requested"]);
                            count_Full_Payment_Received=count_Full_Payment_Received+parseInt(e["Full Payment Received"]);
                            count_Delivered=count_Delivered+parseInt(e["Delivered"]);
                            count_Cancelled=count_Cancelled+parseInt(e["Cancelled"]);

                            totalSelectedServiceCount=totalSelectedServiceCount+1;
                            totalSignedUpTargetPercentage=totalSignedUpTargetPercentage+parseInt(e["actual_signed_up_target"]);
                            totalDeliveredTargetPercentage=totalDeliveredTargetPercentage+parseInt(e["actual_delivered_target"]);
                            totalSignedUpActualPercentage=totalSignedUpActualPercentage+parseInt(e["total_signedup_target"]);
                            totalDeliveredActualPercentage=totalDeliveredActualPercentage+parseInt(e["total_delivered_target"]);
                            
                        }
                    });
                }
            });

            

            arrChartData.push(
                ['Services', 'number'],
                ['Requested', count_Requested],
                ['Eligible', count_Eligible],
                ['Quotation Sent', count_Quotation_Sent],
                ['Prepared', count_Prepared],
                ['Partial Payment Pending', count_Partial_Payment_Pending],
                ['Payment Received', count_Payment_Received],
                ['Ready For Progression', count_Ready_For_Progression],
                ['Awaiting For Information/Documents',count_Awaiting_For_Information_Documents],
                ['Payment Confirmed By Partner', count_Payment_Confirmed_By_Partner],
                ['Service Delivery Start', count_Service_Delivery_Start],
                ['Service Deliverables ready', count_Service_Deliverables_Ready],
                ['Full Payment Requested', count_Full_Payment_Requested],
                ['Full Payment Received', count_Full_Payment_Received],
                ['Delivered', count_Delivered],
                ['Cancelled', count_Cancelled],
            );
            setChartData(arrChartData);

            let Services_count=count_Requested+count_Eligible+count_Quotation_Sent+
            count_Prepared+count_Partial_Payment_Pending+count_Ready_For_Progression+
            count_Awaiting_For_Information_Documents+count_Service_Delivery_Start+
            count_Service_Deliverables_Ready+count_Full_Payment_Requested+count_Full_Payment_Received+count_Cancelled;

            let Services_Signed_upCount=count_Payment_Received+count_Payment_Confirmed_By_Partner+count_Delivered;

            let totalServiceRequets=Services_Signed_upCount+Services_count;

            let Total_Services_Signed_up_per=((Services_Signed_upCount/totalServiceRequets)*100).toFixed(2);
            let Total_Delivered_To_SignedUp_per=((count_Delivered/Services_Signed_upCount)*100).toFixed(2);

            if(Total_Services_Signed_up_per==="NaN")
            {
                Total_Services_Signed_up_per="0.00";
            }
            if(Total_Delivered_To_SignedUp_per==="NaN")
            {
                Total_Delivered_To_SignedUp_per="0.00";
            }

            let SignedUpTargetPercentage=parseInt((totalSignedUpTargetPercentage/totalSelectedServiceCount));
            let DeliveredTargetPercentage=parseInt((totalDeliveredTargetPercentage/totalSelectedServiceCount));
            let SignedUpActualPercentage=parseInt((totalSignedUpActualPercentage/totalSelectedServiceCount));
            let DeliveredActualPercentage=parseInt((totalDeliveredActualPercentage/totalSelectedServiceCount));

            if(SignedUpTargetPercentage==="NaN")
            {
                SignedUpTargetPercentage=0;
            }
            if(DeliveredTargetPercentage==="NaN")
            {
                DeliveredTargetPercentage=0;
            }
            if(SignedUpActualPercentage==="NaN")
            {
                SignedUpActualPercentage=0;
            }
            if(DeliveredActualPercentage==="NaN")
            {
                DeliveredActualPercentage=0;
            }

            setSignedUpTargetPer(SignedUpTargetPercentage);
            setDeliveredTargetPer(DeliveredTargetPercentage);
            setSignedUpActualPer(SignedUpActualPercentage);
            setDeliveredActualPer(DeliveredActualPercentage);

            setSigned_up_to_Service_Requested(Total_Services_Signed_up_per+"%");
            setDelivered_to_Signed_Up(Total_Delivered_To_SignedUp_per+"%");
            setsignedUpServicesCount(Services_Signed_upCount);
            setDeliveredServicesCount(count_Delivered);
        } 
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    const handleSearchClick = async () => {
        //setServiceData(strData);
        getESPServiceData();
        getFirstResponseTimeData();
        getCustomerSatisfactionScoreData();
        //toggleFilterModal();
        //onExternalServicePartnerChange();
	};

    const onClearFilterSearch=()=>{
        setfromDate("");
        settoDate("");
        let temp =[{label: "All", value: "*"}];
        let tempSR = serviceNameListForFilter.map((e) => 
        {
            if (!temp.includes(e)) 
            {
                temp = temp.concat(e);
            }
            return e;
        });
        setSelectedServiceNameListForFilter(temp);
        setSelectedPackageNameListForFilter(null);
    }

    const toggleAllForFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length!=(serviceNameListForFilter.length+1)) 
		{
			if(selectedServiceNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
		} 
		else
		{
			setSelectedServiceNameListForFilter([]);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};

    const calculateDaysLeft=(startDate, endDate)=> {
        if (!moment.isMoment(startDate)) startDate = moment(startDate);
        if (!moment.isMoment(endDate)) endDate = moment(endDate);

        //return endDate.diff(startDate, "days");

        var days=endDate.diff(startDate, "days");
        var target =days*5;

        setSignedUpTarget(target);
        setDeliveredTarget(target);
    }
    
    // for Admin
    const onExternalServicePartnerChange=(option)=>{
        var ESPServiceCodeList=[];
        MainExterServicePartnerList.map((f) => 
        {
            if(!option)
            {
                option=selectedExternalServicePartner;
            }
            if(f.sServicePartnerEmail===option.value)
            {
                ESPServiceCodeList=f.sServiceCode_list;
            }
        });

        const serviceReqNamesForFilter = MainServiceRequestsNameList.map((idx) => {
            return {
                label: idx.sServiceName,
                id: idx.id,
                value: idx.sServiceCode,
            };
        });
        
        let tempserviceReqNamesForFilter=[];
        if(ESPServiceCodeList.length>0)
        {
            serviceReqNamesForFilter.map((e) => {
                if(ESPServiceCodeList.includes(e.value))
                {
                    tempserviceReqNamesForFilter.push(e);
                }
            });
        }
        else
        {
            tempserviceReqNamesForFilter=serviceReqNamesForFilter;
        }

        let temp =[{label: "All", value: "*"}];
        let tempSR = tempserviceReqNamesForFilter.map((e) => 
        {
            if (!temp.includes(e)) 
            {
                temp = temp.concat(e);
            }
            return e;
        });

        setServiceNameListForFilter(tempserviceReqNamesForFilter);
        setSelectedServiceNameListForFilter(temp);
        setselectedExternalServicePartner(option);
        setSelectedPackageNameListForFilter(null);        
    }
    
    return(
        <>
        {
            activePage==="SPLedDashboard"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                    <div className="col-2 spled-container conv-zindex">
                                    <div className="width-100">                                       
                                            <ReactDatePicker 
                                                dateFormat="dd/MM/yyyy"
                                                selected={props.fromDate}  
                                                onChange={(date) =>
                                                    
                                                    props.onDateRangeChange("fromDate", date)
                                                }
                                                //minDate={new Date()}
                                                placeholderText="From Date"   
                                                
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2 spled-container conv-zindex">
                                    <div className="width-100">
                                        <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.toDate}
                                        onChange={(date) => props.onDateRangeChange("toDate", date)}
                                        placeholderText="To Date"
                                        />
                                    </div>
                                    </div>
                                    <Button className="esp-inline-button" onClick={handleSearchClick}>Search</Button>

 
                                        <div className="col-3">
                                            <div className="esp-dashboard-card conv-text-center">
                                                <label className="esp-box-header-title">First Time Users</label> 
                                                {/* <h5 className="esp-count-text">{ServiceData.ServiceRequests}</h5> */}
                                                <div style={{clear:"both"}}></div>
                                                 
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="esp-dashboard-card conv-text-center">
                                                <label className="esp-box-header-title">Engaged Users</label> 
                                                {/* <h5 className="esp-count-text">{ServiceData.ServiceRequests}</h5> */}
                                                <div style={{clear:"both"}}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15">
                                    <div className="row">
                                        <div className="col-6">
                                        <div className="esp-dashboard-card conv-text-center" style={{height:"311px"}}>
                                        <label className="esp-box-header-title">Resource Availed by First Time Users</label> 
                                        <div className="google-chart">
                                            {/* <Chart
                                                width={'100%'}  
                                                height={'260px'}
                                                chartType="PieChart"                                    
                                                data={ChartData}
                                                options={{
                                                    backgroundColor:"#FAFAFA",
                                                    title: '',
                                                    // Just add this option
                                                    is3D: true,
                                                    legend: { position: 'left' },
                                                    chartArea: {
                                                        left: 0,
                                                        top: 10,
                                                        right: 0,
                                                        bottom:0,
                                                        width: "100%",
                                                        height: "100%"
                                                    },
                                                }}
                                                chartEvents={chartEvents}
                                                rootProps={{ 'data-testid': '2' }}
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                        <div className="esp-dashboard-card conv-text-center" style={{height:"311px"}}>
                                        <label className="esp-box-header-title">Resource Availed by First Time Users</label> 
                                        <div className="google-chart">
                                            {/* <Chart
                                                width={'100%'}  
                                                height={'260px'}
                                                chartType="PieChart"                                    
                                                data={ChartData}
                                                options={{
                                                    backgroundColor:"#FAFAFA",
                                                    title: '',
                                                    // Just add this option
                                                    is3D: true,
                                                    legend: { position: 'left' },
                                                    chartArea: {
                                                        left: 0,
                                                        top: 10,
                                                        right: 0,
                                                        bottom:0,
                                                        width: "100%",
                                                        height: "100%"
                                                    },
                                                }}
                                                chartEvents={chartEvents}
                                                rootProps={{ 'data-testid': '2' }}
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                               {/* <div className="col-12 conv-mt15">
                                    <div className="esp-dashboard-card conv-text-center" style={{height:"310px"}}>
                                        <label className="esp-box-header-title">Service Status</label> 
                                        <div className="google-chart">
                                            <Chart
                                                    width={'100%'}
                                                    height={'270px'}
                                                    chartType="PieChart"                                    
                                                    data={ChartData}
                                                    options={{
                                                        backgroundColor:"#FAFAFA",
                                                        title: '',
                                                        // Just add this option
                                                        is3D: true,
                                                        legend: { position: 'left' },
                                                        chartArea: {
                                                            left: 0,
                                                            top: 10,
                                                            right: 0,
                                                            bottom:0,
                                                            width: "100%",
                                                            height: "100%"
                                                        },
                                                    }}
                                                    chartEvents={chartEvents}
                                                    rootProps={{ 'data-testid': '2' }}
                                                />
                                        </div>
                                    </div>
                                                </div>*/}
                            </div>
                        </div>
                         
                        
                        {/* <div className="col-4">
                            <div className="esp-card">
                                <div className="esp-container">
                                    <h5><b>Select Date</b></h5> 
                                    <div className="inline-view-date-picker">
                                        <ReactDatePicker
                                            dateFormat="dd/MM/yyyy"
                                            selected={fromDate}
                                            onChange={(date) =>setfromDate(date)}
                                            placeholderText="Service Request From Date"
                                        />
                                        <ReactDatePicker
                                            dateFormat="dd/MM/yyyy"
                                            selected={toDate}
                                            onChange={(date) =>settoDate(date)}
                                            placeholderText="Service Request To Date"
                                        />
                                    </div>
                                    <div style={{textAlign:"center"}}>
                                        <Button className="esp-inline-button" onClick={handleSearchClick}>Search</Button>                                
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="row conv-mt30 conv-mb30">
                         
                        <div className="col-6 service-partner spled-container engagedusers-report">
                            <EngagedDashboardGrid
                            data={TableData}
                            ServiceData={ServiceData}
                            fromNewDesign={true}
                            />
                        </div>
                        <div className="col-6 service-partner spled-container engagedusers-report">
                            <EngagedDashboardGrid
                            data={TableData}
                            ServiceData={ServiceData}
                            fromNewDesign={true}
                            />
                        </div>
                    </div>
                </div>
            ):
            activePage==="No_Access"?
            (
                <div className={`row row-container`}>
                        <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                        <label>
                            <b>You are not allowed to access this page, Please contact admin for more details.</b>
                        </label>         
                    </div>
                </div>
            )
            :
            (
                ""
            )
        }
        {
            showFilterModal&&
            (
                <SPLedDashboardFilterModal
                    isOpen={showFilterModal}
                    toggleModal={toggleFilterModal}
                    toggleAllForFilter={toggleAllForFilter}
                    toggleSelectionForFilter={toggleSelectionForFilter}
                    serviceNameListForFilter={serviceNameListForFilter}
                    selectedServiceNameListForFilter={selectedServiceNameListForFilter}
                    packageNameListForFilter={packageNameListForFilter}
                    setSelectedPackageNameListForFilter={setSelectedPackageNameListForFilter}
                    selectedPackageNameListForFilter={selectedPackageNameListForFilter} 
                    fromDate={fromDate}
                    toDate={toDate}
                    setfromDate={setfromDate}
                    settoDate={settoDate}
                    handleSearchClick={handleSearchClick} 
                    onClearFilterSearch={onClearFilterSearch} 
                    externalServicePartnerList={externalServicePartnerList}
                    onExternalServicePartnerChange={onExternalServicePartnerChange}
                    selectedExternalServicePartner={selectedExternalServicePartner} 
                    isForAdmin={history.location.pathname.includes("/home/engagedusers-report")}                 
                >
                </SPLedDashboardFilterModal>
            )
        }
            
        </>
    );
}